import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';

export function CaptureActivityThumbnail({
  image,
  alt,
  size = 52,
}: {
  image: Blob;
  alt: string;
  size?: number;
}) {
  const url = useMemo(() => URL.createObjectURL(image), [image]);
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 1,
        overflow: 'hidden',
        bgcolor: 'grey.100',
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Box
        component="img"
        src={url}
        alt={alt}
        loading="lazy"
        decoding="async"
        sx={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </Box>
  );
}
